<div
  [class]="groupClass()"
  role="radiogroup"
  [attr.aria-label]="ariaLabel() || null"
  [attr.aria-labelledby]="ariaLabelledby() || null"
>
  <ng-content />
</div>
